import clsx from 'clsx';
import __isEmpty from 'lodash/isEmpty';
import Image from 'next/image';
import { dataResources } from '../../../utils/constants';
import styles from './codiespectador.module.scss';

const { basePath } = dataResources;

export default function CodiEspectador(props) {
    const { codi = '', alt = '', mida = '20', className = '', estil } = props;

    let codiEdat = codi?.replace('PUCE_', '').replace('CE_', '').replace(/^0+/, '');

    if (codiEdat === 'DA') {
        return false;
    }

    const altEdat = !__isEmpty(alt) && !isNaN(codiEdat) ? codiEdat + ' anys' : alt;

    const styleIcona = clsx({
        [styles[estil]]: !__isEmpty(estil),
        [className]: !__isEmpty(className)
    });

    let src = basePath + '/_resources/icones/codisEspectador/codisEspectador' + codiEdat + '.svg?v=JIT_ENV_RESOURCES_VERSION';

    const imageLoader = ({ src }) => {
        return `${src}`;
    };

    return (
        codiEdat && (
            <span className={styleIcona} data-testid={`codi-espectador-${codiEdat}`} aria-label={'Edat recomanada ' + altEdat}>
                <Image
                    loader={imageLoader}
                    width={codiEdat === 'AD' ? mida * 1.6 : mida}
                    height={mida}
                    alt=''
                    src={src}
                    unoptimized={true}
                    aria-hidden={true}
                />
            </span>
        )
    );
}
